import classNames from "classnames/bind";
import styles from "./Header.module.scss";

import { useState } from "react";

const cx = classNames.bind(styles);

function Header() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Close the mobile menu when a link is clicked
  const handleLinkClick = () => {
    setIsOpen(false);
  };

  return (
    <header className={cx("header")}>
      <a className={cx("logo")} href="#">
        GiveWell
      </a>

      <div className={cx("nav-container")}>
        <nav className={cx("nav")}>
          <ul className={cx("nav-list")}>
            <li className={cx("nav-item")}>
              <a href="#ourmission">Our mission</a>
            </li>
            <li className={cx("nav-item")}>
              <a href="#empower">Empower</a>
            </li>
            <li className={cx("nav-item")}>
              <a href="#ourteam">Our Team</a>
            </li>
            <li className={cx("nav-item")}>
              <a href="#ourvision">Our Vision</a>
            </li>
            <li className={cx("nav-item")}>
              <a href="#ourimpact">Our Impact</a>
            </li>
          </ul>
        </nav>

        <div className={cx("donate-button")}>
          <a href="#donate" className={cx("button")}>
            Donate
          </a>
        </div>
      </div>

      <div onClick={toggleMenu} className={cx("hamburger")}>
        <div className={cx("line")}></div>
        <div className={cx("line")}></div>
        <div className={cx("line")}></div>
      </div>
      {isOpen && (
        <div className={cx("mobile-menu")}>
          <ul className={cx("mobile-nav-list")}>
            <li className={cx("mobile-nav-item")}>
              <a href="#ourmission" onClick={handleLinkClick}>
                Our mission
              </a>
            </li>
            <li className={cx("mobile-nav-item")}>
              <a href="#empower" onClick={handleLinkClick}>
                Empower
              </a>
            </li>
            <li className={cx("mobile-nav-item")}>
              <a href="#ourteam" onClick={handleLinkClick}>
                Our Team
              </a>
            </li>
            <li className={cx("mobile-nav-item")}>
              <a href="#ourvision" onClick={handleLinkClick}>
                Our Vision
              </a>
            </li>
            <li className={cx("mobile-nav-item")}>
              <a href="#ourimpact" onClick={handleLinkClick}>
                Our Impact
              </a>
            </li>
            <li className={cx("mobile-donate-button")}>
              <a
                href="#donate"
                className={cx("button")}
                onClick={handleLinkClick}
              >
                Donate
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}

export default Header;
